export default __webpack_public_path__ + "static/media/kasikira.b0fdac83.jpg";